<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
          @titleClick='onSelectedVendor'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.거래처명}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <HardwarePurchaseInputPivotComponent ref='refOthersPurchaseInputPivotComponent' @refresh-input-vendor-list="refreshInputVendorList"
    pType='S0106' materialType='S0404,S0406,S0410' :company="company" :selected-vendor="selectedVendor" />
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxTabPanel from 'devextreme-vue/tab-panel'
import HardwarePurchaseInputPivotComponent from './HardwarePurchaseInputPivotComponent'
import AppLib from '../../share/AppLib'

export default {
  name: 'PurchasePivotTab',
  data: function () {
    return {
      selectedIndex: 0,
      tabs: [
        {
          title: '자재구매내역'
        }
      ],
      company: null,
      thisYear: null,
      selectedMonth: null,
      selectedVendor: null
    }
  },
  components: {
    DxTabPanel,
    HardwarePurchaseInputPivotComponent
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    let user = this.$store.getters.getUserInfo
    if (user === undefined || user === null) {
      this.$router.push('/')
    }
    // this.init()
    this.refreshInputVendorList(`${AppLib.getThisYear()}-${AppLib.getThisMonth()}`)
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {
    this.$store.commit('deleteInoutList')
  },
  methods: {
    init () {
      this.thisYear = AppLib.getThisYear()
      this.selectedMonth = AppLib.getThisMonth()
    },
    onSelectedVendor () {
      this.selectedVendor = this.tabs[this.selectedIndex].입고업체
      this.company = this.tabs[this.selectedIndex].거래처명
      this.$refs.refOthersPurchaseInputPivotComponent.refreshDataGridFromParent(this.selectedVendor)
    },
    refreshInputVendorList (date) {
      console.log(`${date}-${AppLib.getMonthLastDay(date.split('-')[0], date.split('-')[1])} 23:59:59`)
      const param = {
        자재유형: `${ConstDef.부자재},${ConstDef.사급품},${ConstDef.소모품}`
      }
      this.$_sp.runNoEncodeFindProc('spFindAllVendorListOfPurchaseType', param)
        .then((data) => {
          this.tabs = this.$_sp.MakeModel(data)
          console.log(this.tabs)
          this.company = this.tabs[this.selectedIndex].거래처명
          if (!(this.selectedVendor !== null && this.selectedVendor !== undefined)) this.selectedVendor = this.tabs[0].입고업체
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
